import Subscribe from "components/Subscribe";
import type { SubscribeProps } from "components/Subscribe";

interface SubscribeAdapterProps {
  blok: SubscribeProps;
}

const SubscribeAdapter = ({ blok: { heading, text, buttonText, listId } }: SubscribeAdapterProps) => (
  <Subscribe heading={heading} text={text} buttonText={buttonText} listId={listId} />
);

export default SubscribeAdapter;
